import { toggleBooleanAttribute } from "../utility/dom-manipulation";

export const navToggle = document.getElementById( 'primary-navigation-toggle' );

/**
 * Toggles the aria expanded attribute when clicked. Menu should be styled to show when this attribute is true
 */
export function setupNavToggle() {
  navToggle.addEventListener( 'click', (e) => {
    const self = e.currentTarget;
    toggleBooleanAttribute( 'aria-expanded', self );
  } );
}

/**
 * Sets all site footer links to also close the nav menu when clicked
 */
export function setUpFooterLinks() {
  document.querySelectorAll( '[href="#site-footer"]' ).forEach( footer_link =>
    footer_link.addEventListener( 'click', () => {
      navToggle.setAttribute( 'aria-expanded', 'false' );
    })
  );
}